module.exports = __webpack_public_path__ + "img/logo-amalan-uangme.1850d4c5.png";